import { useState, useEffect } from "react";
import PromoteursHeader from "./PromoteursHeader";
import PromoteursBody from "./PromoteursBody";
import PromoteursAdminBody from "./PromoteursAdminBody";
import { useDispatch, useSelector } from "react-redux";
import {
  getPromoteurs,
  getSecteurs,
} from "../../../redux/actions/promoteursActions";
import Pagination from "../../../components/commons/Pagination";
import {
  getAgencies,
  syncAgencies,
} from "../../../redux/actions/agenciesActions";

const AgenciesList = () => {
  const dispatch = useDispatch();
  const { role } = useSelector((state) => state.userAuthReducer);
  const [searchfilter, setSearchfilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    field: "updatedAt",
    direction: "desc",
  });
  const { agencies, loading, length } = useSelector(
    (state) => state.agenciesReducer
  );

  const handleItemSearch = () => {};

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  return (
    <div>
      <PromoteursHeader
        showSearch={false}
        searchfilter={searchfilter}
        setSearchfilter={setSearchfilter}
        handleItemSearch={handleItemSearch}
        showButton={true}
        buttonText="Synchroniser les agences"
        buttonCallBack={() => dispatch(syncAgencies())}
      />
      <div className="bg-white bold d-flex radius05 my-2 p-3 pink ">
        <div className="flex-1">Nom</div>
        <div className="w30">Note Google</div>
        <div className="w30 ">Note Immodvisor</div>
      </div>
      <div className="d-flex gap-2 flex-column">
        {agencies.map((agency) => (
          <div
            key={agency.id}
            className="bg-white bold d-flex radius05 my-2 p-3"
          >
            <div className="flex-1">{agency.name}</div>
            <div className="w30">{`${agency.google_rate || "-"}/5 (${
              agency.google_total_reviews || "-"
            })`}</div>
            <div className="w30 ">{`${agency.immodvisor_rate || "-"}/5 (${
              agency.immodvisor_total_reviews || "-"
            })`}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AgenciesList;
